import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

const mutation = graphql`
  mutation unarchiveEventMutation($input: unarchiveHyeventInput!){
    unarchiveHyevent(input: $input) {
      hyevent{
        id
        title
        maxNoOfGuests
        additionalGuestAllowed
        maxAdditionalGuests
        ctaText
        messageTitle
        message
        address
        status
        propertyId
        startAt
        endAt
        publishAt
        cancelReason
        rsvpedCount
        image{
          id
          fileType
          fileSize
          fileUrl
          dimension
          thumbnailUrl
        }
      }
    }
  }
`;

function commit(environment, input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
};

export default commit;